import {
  getKnowledgeArticleLink,
} from '../../utils/knowledge/knowledgeArticles';
import { KnowledgeChannel } from '../../utils/knowledge/types';
import {
  getKnowledgeUiCopy,
  KNOWLEDGE_CONTACT_EMAIL,
  KnowledgeLocale,
} from '../../utils/knowledge/knowledgeCopy';
import {
  KnowledgeContactButton,
  KnowledgeSidebar,
  KnowledgeSidebarItem,
  KnowledgeSidebarLink,
  KnowledgeSidebarList,
} from './KnowledgeCentre.styles';

interface KnowledgeHelpSidebarProps {
  channel: KnowledgeChannel;
  locale: KnowledgeLocale;
  topArticles: { urlName: string; title: string }[];
}

export const KnowledgeHelpSidebar = ({ channel, locale, topArticles }: KnowledgeHelpSidebarProps) => {
  const ui = getKnowledgeUiCopy(locale);
  const channelProp = { $channel: channel };

  return (
    <KnowledgeSidebar>
      <h2>{ui.topArticles}</h2>
      <KnowledgeSidebarList>
        {topArticles.map(({ urlName, title }) => (
          <KnowledgeSidebarItem key={urlName}>
            <KnowledgeSidebarLink href={getKnowledgeArticleLink(locale, channel, urlName)}>
              {title}
            </KnowledgeSidebarLink>
          </KnowledgeSidebarItem>
        ))}
      </KnowledgeSidebarList>
      <KnowledgeContactButton
        {...channelProp}
        href={`mailto:${KNOWLEDGE_CONTACT_EMAIL}`}
      >
        {ui.contactSupport}
      </KnowledgeContactButton>
    </KnowledgeSidebar>
  );
};
